import React, { useState, useEffect } from 'react';
import IconWrapper from '/react4xp/components/Icon';
import { AccentArrow } from '../Svg/Others/Icons';

interface AnimatedIconProps {
    animationPath: string;
    label: string;
    href: string;
    target?: string;
}

export default function AnimatedIcon({ animationPath, label, href, target }: AnimatedIconProps) {

    return (
        <a href={href} target={target} className="our-solutions__solution-item">
            <div className="our-solutions__solution-icon" data-animation-path={animationPath}></div>
            <div className="our-solutions__solution-label">
                <p>{label}</p>
                <IconWrapper className='our-solutions__solution-arrow' iconColor='text-light' IconComponent={AccentArrow} />
            </div>
        </a>
    );
}
